import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Header = styled.header`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  gap: 5px;
  margin: 10px 0 10px 10px;
  color: ${theme.colors.black};
`

export const Container = styled.div`
  margin: 15px;
  @media (min-width: 768px) {
    margin: 0 30%;
  }
`

export const WrapperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`

export const Section = styled.section`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: ${theme.colors.green3};
`
